const c = {
  name: "Console",
  dimensions: { width: 39, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.2 40" style="enable-background:new 0 0 39.2 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19.6,17.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2
			C18.3,16.7,18.9,17.2,19.6,17.2z"/>
		<path class="st0" d="M10.1,22.5h-2V20H5.6v-2h2.5v-2.5h2V18h2.5v2h-2.5V22.5z"/>
		<path class="st0" d="M33.8,19c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C33.3,17.8,33.8,18.3,33.8,19z"
			/>
		<path class="st0" d="M27.6,20.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2
			C26.3,19.7,26.9,20.2,27.6,20.2z"/>
		<path class="st0" d="M31.3,16.5c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2
			C30.8,15.2,31.3,15.8,31.3,16.5z"/>
		<path class="st0" d="M30.1,22.8c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2
			C28.8,22.2,29.4,22.8,30.1,22.8z"/>
		<path class="st0" d="M39.1,34.7l-1.9-18.2c-0.2-1.8-1-3.5-2.4-4.7c-1.3-1.2-3.1-1.9-4.9-1.9c-0.1,0-0.2,0-0.3,0l0,0v0h-9V0h-2v10
			h-9v0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-1.8,0-3.6,0.7-4.9,1.9C3,13.1,2.2,14.7,2,16.5L0,34.7c-0.1,1.3,0.3,2.7,1.2,3.7
			c0.9,1,2.2,1.6,3.6,1.6c1.4,0,2.8-0.6,3.7-1.8l4.3-5.2c2.4-0.1,4.3-1.8,4.7-4h4.2c0.4,2.2,2.4,3.9,4.7,4l4.3,5.3
			c0.9,1.1,2.2,1.8,3.7,1.8c1.4,0,2.6-0.6,3.6-1.6C38.8,37.4,39.3,36,39.1,34.7L39.1,34.7z M24.9,12c-1.4,1.3-2.3,3.2-2.3,5.3V25
			c-0.4,0.6-0.7,1.2-0.9,2h-4.2c-0.1-0.7-0.4-1.4-0.9-2v-7.7c0-2.1-0.9-4-2.3-5.3H24.9z M6.9,37c-0.5,0.6-1.3,1-2.1,1
			s-1.5-0.3-2.1-0.9S1.9,35.7,2,34.9l1.9-18.2c0.1-1.3,0.8-2.5,1.7-3.4c1-0.9,2.2-1.4,3.6-1.4c2.9,0,5.3,2.4,5.3,5.3v6.1
			c0,0,0,0-0.1,0c-0.3-0.1-0.6-0.2-0.9-0.3h0c-0.3-0.1-0.7-0.1-1-0.1c-2.8,0-5,2.2-5,5c0,0.3,0,0.6,0.1,0.9l0.1,0.3
			c0.1,0.2,0.1,0.4,0.2,0.6C7.9,29.9,8,30,8,30.1c0.1,0.2,0.2,0.5,0.4,0.7c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0.1
			c0.1,0.2,0.3,0.3,0.4,0.5c0.1,0.1,0.1,0.1,0.2,0.2c0.2,0.1,0.3,0.3,0.5,0.4c0,0,0.1,0.1,0.1,0.1s0.1,0.1,0.1,0.1
			c0.2,0.1,0.4,0.3,0.7,0.4L6.9,37L6.9,37z M12.6,31c-0.1,0-0.3,0-0.4,0l0,0c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.1,0-0.2-0.1
			c0,0-0.1,0-0.1,0c-0.1,0-0.2-0.1-0.3-0.1c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1
			c0,0-0.1-0.1-0.1-0.1c0,0,0,0-0.1-0.1c0,0-0.1,0-0.1-0.1c-0.1,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0-0.1
			c-0.1-0.1-0.1-0.2-0.2-0.2c0,0-0.1-0.1-0.1-0.2c0,0,0,0,0-0.1c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.1-0.1-0.2c0,0,0-0.1,0-0.1
			c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2c0-0.2-0.1-0.4-0.1-0.6c0-1.6,1.3-3,3-3c0.2,0,0.4,0,0.7,0.1c0.6,0.1,1.2,0.5,1.6,0.9
			c0.5,0.6,0.8,1.3,0.8,2C15.6,29.6,14.3,31,12.6,31L12.6,31z M23.6,28c0-0.7,0.3-1.4,0.8-2c0.6-0.6,1.4-1,2.2-1c1.6,0,3,1.4,3,3
			s-1.2,2.9-2.8,3h-0.2C24.9,31,23.6,29.6,23.6,28z M36.4,37.1c-0.5,0.6-1.3,0.9-2.1,0.9s-1.6-0.4-2.2-1l-3.6-4.4c0,0,0,0,0.1,0
			c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0.1,0c0.2-0.1,0.4-0.2,0.5-0.3c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0.2-0.1,0.3-0.3,0.5-0.4
			c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1-0.1c0.2-0.2,0.4-0.4,0.5-0.7c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0.1-0.2,0.2-0.4,0.3-0.6
			c0-0.1,0.1-0.1,0.1-0.2c0,0,0,0,0-0.1c0.1-0.2,0.1-0.4,0.2-0.6c0,0,0-0.1,0-0.1s0-0.1,0-0.1c0-0.3,0.1-0.6,0.1-0.9
			c0-2.8-2.2-5-5-5c-0.3,0-0.7,0-1,0.1h0c-0.3,0.1-0.6,0.2-0.9,0.3c0,0,0,0,0,0v-6.1c0-2.9,2.4-5.3,5.3-5.3c1.3,0,2.6,0.5,3.6,1.4
			c1,0.9,1.6,2.1,1.7,3.4l1.9,18.2C37.2,35.7,37,36.5,36.4,37.1L36.4,37.1z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Console
};
